/** One grey icon per result, from the icon vocabulary; projects show their avatar. */
import {
  CONCEPT_ICONS,
  ProjectAvatar,
  getFrameTypeIcon,
} from "@/components/ui";
import { settingsRootIcon } from "@/components/settings/settings-navigation";
import type { HubResult } from "./hub-types";

const ICON_CLASS = "h-4 w-4 text-muted";

export function ResultIcon({ result }: { result: HubResult }) {
  switch (result.kind) {
    case "chat":
      return <CONCEPT_ICONS.chat className={ICON_CLASS} aria-hidden="true" />;
    case "task":
      return <CONCEPT_ICONS.task className={ICON_CLASS} aria-hidden="true" />;
    case "frame": {
      const Icon = getFrameTypeIcon(result.frameType);
      return <Icon className={ICON_CLASS} aria-hidden="true" />;
    }
    case "memory":
      return <CONCEPT_ICONS.memory className={ICON_CLASS} aria-hidden="true" />;
    case "project":
      return result.color ? (
        <ProjectAvatar
          name={result.title}
          color={result.color}
          isHome={result.isHome}
          size="sm"
          data-testid={`hub-row-project-${result.id}-avatar`}
        />
      ) : (
        <CONCEPT_ICONS.project className={ICON_CLASS} aria-hidden="true" />
      );
    case "agent":
      return <CONCEPT_ICONS.agent className={ICON_CLASS} aria-hidden="true" />;
    case "setting": {
      const Icon = settingsRootIcon(result.page);
      return <Icon className={ICON_CLASS} aria-hidden="true" />;
    }
  }
}
